export class WebStoriesTextboxOrButton
{
    public text: any;
    public leftAlignment: boolean;
    public rightAlignment: boolean;
    public topAlignment: boolean;
    public bottomAlignment: boolean;
    public leftMargin: any;
    public rightMargin: any;
    public topMargin: any;
    public bottomMargin: any;
    public left: boolean;
    public right: boolean;
    public top: boolean;
    public bottom: boolean;
    public textAlignment: any;
    public fontFamily: any;
    public fontSize: any;
    public fontStyle: any;
    public fontColor: any;
    public borderColor: any;
    public borderStyle: any;
    public backgroundColor: any;
    public textAnimation: any;
    public type: any;
    public url: any;
    public textTransform: any;
    public cornerRadius: any;
    public borderLeft: boolean;
    public borderRight: boolean;
    public borderTop: boolean;
    public borderBottom: boolean;
    public border: boolean;
    public textboxCSS : any;
    public position : any;
    public topBottomCenter : any;
    public leftRightCenter : any;
    public width: any;
    public bottomPadding: any;
    public topPadding: any;

    constructor()
    {
        this.leftAlignment = false;
        this.rightAlignment = false;
        this.topAlignment = false;
        this.bottomAlignment = false;
        this.leftMargin = '28.3333%';
        this.rightMargin = 'auto';
        this.topMargin = '48.1043%';
        this.bottomMargin = 'auto';
        this.left = false;
        this.right = false;
        this.top = false;
        this.bottom = false;
        this.textAlignment = 'center';
        this.fontFamily = "Calibri, sans-serif";
        //this.fontSize = "18px";
        this.fontSize = "1.125em";
        this.fontStyle = "400";
        // this.fontColor = '#000000';
        // this.borderColor = '#FFFFFF';
        // this.backgroundColor = '#FFFFFF';
        this.fontColor = '#000000';
        this.borderColor = '#000000';
        this.backgroundColor = null;
        this.type = 'textbox';
        this.url = null;
        this.borderStyle = 'solid';
        this.text = 'Enter text Here';
        this.textTransform = 'inherit';
        this.cornerRadius = '1px';
        this.borderLeft = false;
        this.borderRight = false;
        this.borderTop = false;
        this.borderBottom = false;
        this.border = true;
        this.textboxCSS = null;
        this.position = 'absolute';
        this.topBottomCenter = true;
        this.leftRightCenter = true;
        //this.width = '40.63%';
        this.width = '43.34%';
        this.topPadding = '1.25%';
        this.bottomPadding = '1.25%';
    }
}